'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg = require('../../utils/svg.utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controls = (0, _svg.getSvgControls)();
var Svg = controls.Svg,
    Path = controls.Path;

var Lightning = function (_React$Component) {
    _inherits(Lightning, _React$Component);

    function Lightning() {
        _classCallCheck(this, Lightning);

        return _possibleConstructorReturn(this, (Lightning.__proto__ || Object.getPrototypeOf(Lightning)).apply(this, arguments));
    }

    _createClass(Lightning, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                Svg,
                { width: '26', height: '32', viewBox: '0 0 26 32' },
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M20.877 13.12c-0.16-0.267-0.427-0.427-0.747-0.427h-5.867l4.16-11.573c0.107-0.267 0.053-0.533-0.107-0.747s-0.427-0.373-0.693-0.373h-6.773c-0.16 0-0.32 0.053-0.427 0.16l-0.107 0.053c-0.107 0.107-0.213 0.213-0.267 0.373l-5.387 16.64c-0.107 0.267-0.053 0.533 0.107 0.747s0.427 0.32 0.693 0.32h6.933l-2.187 12.8c-0.053 0.373 0.16 0.747 0.48 0.853 0.053 0.053 0.16 0.053 0.267 0.053 0.267 0 0.533-0.16 0.64-0.427l9.333-17.653c0.107-0.213 0.107-0.533-0.053-0.8zM12.45 26.72l1.547-8.96c0.053-0.267 0-0.48-0.16-0.693s-0.373-0.32-0.64-0.32h-6.827l4.96-15.307h5.44l-4.16 11.573c-0.107 0.267-0.053 0.533 0.107 0.747s0.427 0.373 0.693 0.373h5.707l-6.667 12.587z' })
            );
        }
    }]);

    return Lightning;
}(_react2.default.Component);

Lightning.propTypes = {
    fill: _react2.default.PropTypes.string
};

exports.default = Lightning;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/icons/svg/lightning.js
// module id = 1112
// module chunks = 0